import { BlogPost as BlogPostType } from '../OverviewEntry'
import { lena } from '../_hooks/authors'

export const meta: BlogPostType = {
  ...lena,
  postTitle: 'Svalka ditt hem i sommarvärmen - 10 smarta knep',
  headerImageUrl: '/blog/blog_12.webp',
  headerImageAlt: 'En lägenhet med fläkt och öppna fönster',
  metaDescription:
    '10 smarta knep för bostadsrättsföreningar att svalka ditt hem i sommarvärmen. Effektiva tips för en behaglig och sval bostad i hettan.',
  publishedAt: new Date(2023, 7, 2),
  slug: 'svalka-ditt-hem-i-sommarvarmen',
  tags: ['Trivsel', 'Sommar'],
  overviewText:
    'När sommaren sveper in och temperaturerna stiger, välkomnas den varma solen av många med glädje. Men när bostaden blir en svettig bastu kan det vara svårt att njuta av sommaren fullt ut. Vi har samlat tio effektiva och smarta tips för att hålla din bostad sval och behaglig under de heta dagarna.',
  children: (
    <>
      <p>
        När sommaren sveper in och temperaturerna stiger, välkomnas den varma solen av många med glädje. Men när
        bostaden blir en svettig bastu kan det vara svårt att njuta av sommaren fullt ut. Vi har samlat tio effektiva
        och smarta tips för att hålla din bostad sval och behaglig under de heta dagarna.
      </p>

      <ol>
        <li>
          Strategiskt vädring: Planera dina vädringstider noga. Under de hetaste tiderna på dagen bör fönster och dörrar
          vara stängda, medan du på kvällen och natten kan öppna dem för att släppa in svalare luft. Korsdrag tidigt på
          morgonen kan vara extra effektivt för att få in frisk och sval luft.
        </li>
        <li>
          Solskydd: Istället för att öppna fönster och dörrar vid soliga dagar, se till att stänga ute solen på bästa
          sätt. Installera solfilm på fönstren och överväg att montera markiser i aluminium. För att ytterligare skärma
          av mot solens strålar kan ni även använda tyglakan eller filtar.
        </li>
        <li>
          Fläktar: Luftkonditionering kan vara en dröm, men ofta dyrt och just i Sverige inte alltid en god investering
          då det oftast inte är såpass varmt. Fläktar är ett mer budgetvänligt alternativ och kan vara mycket effektiva
          om de placeras strategiskt. Placera en skål med is framför fläkten för att ytterligare kyla ner luften i
          rummet.
        </li>
        <li>
          Välj rätt sängkläder: För en behaglig sömn i varma nätter, använd andningsbara material som bomull när du
          väljer sängkläder. Detta hjälper till att reglera kroppstemperaturen och minskar risken för att du ska känna
          dig för varm när du ligger i sängen.
        </li>
        <li>
          Minska värmeutsläpp: Uppmuntra medlemmarna att vara medvetna om sina egna värmeutsläpp i bostaden. Stäng av
          datorer och andra elektroniska enheter när de inte används och undvik att laga mat på spisen under de hetaste
          tiderna på dagen. En enkel sallad eller användning av mikrovågsugnen för matlagning minskar värmeutsläppet
          betydligt.
        </li>
        <li>
          Skapa skuggiga oaser: Om det finns gemensamma utrymmen eller trädgårdar i er bostadsrättsförening, överväg att
          skapa skuggiga områden där medlemmarna kan koppla av och njuta av sommardagarna utan att utsättas för den
          starka solen.
        </li>
        <li>
          Skapa ett grönt tak: Om möjligt, överväg att skapa ett grönt tak på byggnaden. Gröna tak fungerar som
          naturliga isolatorer och bidrar till att hålla byggnaden svalare under sommaren.
        </li>
        <li>
          Informera medlemmarna: Se till att kommunicera dessa tips och råd till alla medlemmar i
          bostadsrättsföreningen. Använd digitala plattformar som <a href="/client/public"> Booet </a> för att nå ut till delar,
          eller hela, föreningen. Ju mer medvetna och engagerade medlemmarna är, desto lättare blir det att hantera
          sommarvärmen tillsammans.
        </li>
      </ol>

      <p>
        Vi hoppas att dessa tips kommer vara till hjälp för er bostadsrättsförening och att ni kan njuta av en behaglig
        och sval sommar i ert hem. Tillsammans kan ni göra sommarvärmen till en njutbar tid för alla!
      </p>
    </>
  ),
}
